import { Controller } from "@hotwired/stimulus";

// Makes an overflowing scroll container reachable by keyboard.
//
// Firefox gives scrollable regions a tab stop on its own; Chrome and Safari do
// not, so a capped list card could only be scrolled with a pointer there. The
// tab stop is added ONLY while the element actually overflows — lists that fit
// (and every list on mobile, where the page scrolls instead) stay out of the
// tab order and add no noise.
//
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this);
    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this.element);
    this.update();
  }

  disconnect() {
    this.observer?.disconnect();
    this.observer = null;
    this.element.removeAttribute("tabindex");
  }

  update() {
    // A 1px slack absorbs sub-pixel row heights, which would otherwise report a
    // permanent one-pixel overflow on some zoom levels.
    const overflows = this.element.scrollHeight > this.element.clientHeight + 1;

    if (overflows) {
      this.element.setAttribute("tabindex", "0");
    } else {
      this.element.removeAttribute("tabindex");
    }
  }
}
